<!-- 一般搜索 -->
<template>
  <el-form-item :label="label">
    <el-input
      v-model="commonInput"
      :placeholder="config.placeholder"
      :clearable="config.clearable"
    />
  </el-form-item>
</template>

<script>
import { inject } from 'vue';

export default {
  kind: 'yq-常规搜索',
  props: {
    // 初始值.
    value: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: '搜索：',
    },
    config: {
      type: Object,
      default() {
        return {
          clearable: true,
          placeholder: '请输入',
        };
      },
    },
  },
  setup(props) {
    const useQuery = inject('useQuery');
    const commonInput = useQuery('commonInput', props.value);
    return {
      commonInput,
    };
  },
};
</script>
